import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'open_with_faire-owf_global_upsell_banner-view';
/**
 * Track impressions of the OwF upsell included as one of the top of page banners
 */
export function trackOpenWithFaireOwfGlobalUpsellBannerView() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
